import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.less']
})
export class MultiSelectDropdownComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
